import axios from "axios";
import { API_URL } from "App";

const api = axios.create();

export const fetchGallery = async () => {
  const response = await api.get(`${API_URL}/gallery`);
  return response;
};
